<template>
  <div>
    <error-modal
      :show="showErrorModal"
      :error="currentError"
      :retry-action="retryAction"
      @close="hideError"
    />
  </div>
</template>

<script>
import ErrorModal from './ErrorModal.vue';

export default {
  name: 'GlobalErrorHandler',
  components: {
    ErrorModal
  },
  data() {
    return {
      showErrorModal: false,
      currentError: null,
      retryAction: null
    };
  },
  mounted() {
    // Listen for HTTP error events
    window.addEventListener('http-error', this.handleHttpError);
  },
  beforeDestroy() {
    // Clean up event listener
    window.removeEventListener('http-error', this.handleHttpError);
  },
  methods: {
    handleHttpError(event) {
      const { error, status, message } = event.detail;
      
      // Show error modal for specific status codes
      if ([401, 403, 404, 500].includes(status)) {
        // Convert Error object to plain object for ErrorModal
        this.currentError = {
          status: status,
          message: message,
          response: {
            status: status,
            data: {
              message: message,
              details: error.response?.data?.details || error.details
            }
          },
          details: error.response?.data?.details || error.details
        };
        this.showErrorModal = true;
      }
    },
    
    hideError() {
      this.showErrorModal = false;
      this.currentError = null;
      this.retryAction = null;
    }
  }
};
</script> 